import type { PaginatedResponse, ListParams } from '@/api/client'
import { buildQuery } from '@/api/client'
import type { Bid } from '@/data'
import api from '..'

export type PaginatedBidRungs = PaginatedResponse<Bid>

export async function getBidRungs(
  params?: ListParams,
): Promise<PaginatedBidRungs> {
  const res = await api.get('/bid-rungs', { params: buildQuery(params) })
  return { data: res.data.data, meta: res.data.meta }
}
